import {
  Box,
  Button,
  Flex,
  Input,
  Select,
  Text,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { BiSearchAlt2, BiUpload } from "react-icons/bi";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BASE_URL_EVENT,
  BASE_URL_MEDIA,
  BASE_URL_USER,
  addGroups,
  getGroupCategory,
  getGroupDetails,
} from "../Redux/App/action";
import { AiOutlinePlus } from "react-icons/ai";
import axios from "axios";

const MyGroups = () => {
  const [grpCat, setGrpCat] = useState(0);
  const accessToken = localStorage.getItem("token");
  const [grpName, setGrpName] = useState("");
  const [image, setImage] = useState(null);
  const [imageId, setImageId] = useState(0);
  const dispatch = useDispatch();
  const imageRef = useRef(null);
  const [contacts, setContacts] = useState([
    { fullName: "", contactNumber: "", dob: "" },
  ]);
  const { groupCategory, allGroup } = useSelector((store) => store.appReducer);

  useEffect(() => {
    dispatch(getGroupCategory);
    dispatch(getGroupDetails);
  }, [dispatch]);

  const handleAddContact = () => {
    setContacts([...contacts, { fullName: "", contactNumber: "", dob: "" }]);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedContacts = [...contacts];
    updatedContacts[index][name] = value;
    setContacts(updatedContacts);
  };
  const handleCreateGroup = () => {
    const formData = new FormData();
    formData.append("groupName", grpName);
    contacts.forEach((contact, index) => {
      formData.append(
        `contactsList.contacts[${index}][contactName]`,
        contact.fullName,
      );
      formData.append(
        `contactsList.contacts[${index}][mobileNumber]`,
        contact.contactNumber,
      );
      formData.append(`contactsList.contacts[${index}][dob]`, contact.dob);
    });
    formData.append("contactsList.contactType", grpCat);
    formData.append("groupCategoryId", grpCat);
    formData.append("groupIcon", imageId);

    axios
      .post(`${BASE_URL_USER}/api/v1/group`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setGrpName("");
        setImage("");
        setImageId("");
        setContacts("");
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const hangleImageChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
  };
  const handleClickImage = () => {
    imageRef.current.click();
  };
  const handleImage = () => {
    const formData = new FormData();

    formData.append("productFiles", image);

    axios
      .post(
        ` ${BASE_URL_MEDIA}/media/file/admin/upload/productfiles?imageGroup=PRODUCT`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Token: 123456,
          },
        },
      )
      .then((response) => {
        setImageId(response.data);
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };
  return (
    <Box p={8} textAlign={"left"}>
      <Text
        color={"#3C375F"}
        fontWeight={"bold"}
        fontSize={24}
        className="oswald-font"
      >
        CREATE GROUP
      </Text>
      <Flex
        mt={10}
        alignItems={"center"}
        w={"100%"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        gap={5}
      >
        <Flex alignItems={"center"} gap={5} w={{ md: "30%", base: "100%" }}>
          <Text fontWeight={"semibold"}>Group Type</Text>
          <Select
            w={"60%"}
            color={"#6FADDC"}
            fontWeight={"semibold"}
            onChange={(e) => setGrpCat(e.target.value)}
          >
            <option>Select from dropdown</option>
            {groupCategory &&
              groupCategory.map((el, i) => (
                <option value={el.id} key={i}>
                  {el.categoryName}
                </option>
              ))}
          </Select>
        </Flex>
        <Flex alignItems={"center"} gap={5} w={{ md: "30%", base: "100%" }}>
          <Text fontWeight={"semibold"}>Group Name</Text>
          <Input
            borderRight={0}
            borderLeft={0}
            borderTop={0}
            borderBottom={"2px solid gray"}
            borderRadius={0}
            mt={-5}
            value={grpName}
            onChange={(e) => setGrpName(e.target.value)}
            w={"60%"}
            _focusVisible={false}
          />
        </Flex>
        <Flex alignItems={"center"} gap={5} w={{ md: "30%", base: "100%" }}>
          <Text fontWeight={"semibold"}>Group Icon</Text>
          <Input
            type="file"
            w={{ md: "50%", base: "60%" }}
            ref={imageRef}
            onChange={hangleImageChange}
            display={"none"}
          />
          <Button onClick={handleClickImage} color={"red"}>
            Choose
          </Button>
          <Tooltip label="upload Image First">
            <Button colorScheme="green">
              <BiUpload size={18} onClick={handleImage} />
            </Button>
          </Tooltip>
        </Flex>
      </Flex>
      <Text mt={5} color={"#200E32"} fontSize={16} fontWeight={"semibold"}>
        Select Members
      </Text>
      <Flex alignItems={"center"} gap={5} mt={2} flexWrap={"wrap"}>
        <Box
          w={28}
          h={{ md: 12, base: 14 }}
          border={"2px solid #97AABD"}
          alignItems={"center"}
          borderRadius={5}
          p={1}
          cursor={"pointer"}
        >
          <Text textAlign={"center"} lineHeight={1.1} fontSize={14}>
            Phone <br />
            Contact
          </Text>
        </Box>
        <Box
          w={28}
          h={{ md: 12, base: 14 }}
          border={"2px solid #97AABD"}
          alignItems={"center"}
          borderRadius={5}
          p={1}
          cursor={"pointer"}
        >
          <Text textAlign={"center"} lineHeight={1.1} fontSize={14}>
            My Wishfy <br />
            Contact
          </Text>
        </Box>
        <Box
          w={28}
          h={{ md: 12, base: 14 }}
          border={"2px solid #97AABD"}
          alignItems={"center"}
          borderRadius={5}
          p={1}
          cursor={"pointer"}
          bg={"#FFE14D"}
        >
          <Text
            textAlign={"center"}
            lineHeight={1.1}
            color={"white"}
            fontWeight={"semibold"}
            fontSize={14}
          >
            Create <br />
            Contact
          </Text>
        </Box>
      </Flex>
      <Box mt={10}>
        {contacts.map((contact, index) => (
          <Flex
            key={index}
            gap={2}
            mt={2}
            alignItems={"center"}
            flexWrap={"wrap"}
          >
            <Input
              type="text"
              name="fullName"
              placeholder="Name"
              value={contact.fullName}
              fontWeight={"semibold"}
              border={0}
              borderRadius={0}
              textAlign={"left"}
              bg={"#F7F7F7"}
              _placeholder={{
                textAlign: "left",
                position: "absolute",
                left: "5",
                color: "black",
              }}
              fontSize={14}
              onChange={(event) => handleInputChange(index, event)}
              w={{ md: "32%", base: "85%" }}
              h={7}
              p={2}
              _focusVisible={false}
            />
            <Input
              type="number"
              name="contactNumber"
              placeholder="Contact Number"
              value={contact.contactNumber}
              fontWeight={"semibold"}
              border={0}
              borderRadius={0}
              bg={"#F7F7F7"}
              textAlign={"left"}
              _placeholder={{
                textAlign: "left",
                position: "absolute",
                left: "5",

                color: "black",
              }}
              fontSize={14}
              onChange={(event) => handleInputChange(index, event)}
              w={{ md: "32%", base: "85%" }}
              h={7}
              p={2}
              _focusVisible={false}
            />
            <Input
              type="date"
              name="dob"
              placeholder="D.O.B"
              value={contact.dob}
              bg={"#F7F7F7"}
              fontWeight={"semibold"}
              borderRadius={0}
              textAlign={"left"}
              border={0}
              p={2}
              _placeholder={{
                textAlign: "left",
                position: "absolute",
                left: "5",
                color: "black",
              }}
              fontSize={14}
              onChange={(event) => handleInputChange(index, event)}
              w={{ md: "32%", base: "85%" }}
              h={7}
              _focusVisible={false}
            />
            <AiOutlinePlus onClick={handleAddContact} size={20} />
          </Flex>
        ))}
      </Box>
      <Button
        bg={"#FC1A64"}
        fontWeight={"bold"}
        className="oswald-font"
        color={"white"}
        w={{ md: "20%", base: "60%" }}
        mt={14}
        _hover={{ bg: "#FC1A64" }}
        onClick={handleCreateGroup}
      >
        SUBMIT
      </Button>
    </Box>
  );
};

export default MyGroups;
